<canvas id="confetti" *ngIf="showCanvas$ | async"></canvas>
